import { useEffect, useState } from "react";
import { PenLine } from "lucide-react";
import api from "../lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { toast } from "sonner";

const imgHtml = (f) => `<img src="${f.image}" alt="Firma" style="${f.width60 ? `width:${f.width60}px;` : ""}max-height:60px;height:auto">`;

// Sostituisce tutte le firme già presenti nella lettera con quella selezionata.
const replaceFirme = (ed, f) => {
  if (!ed) return 0;
  const { state } = ed;
  let tr = state.tr, n = 0;
  state.doc.descendants((node, pos) => {
    if (node.type.name === "image" && node.attrs.alt === "Firma") {
      tr = tr.setNodeMarkup(pos, undefined, { ...node.attrs, src: f.image, width: f.width60 || null });
      n += 1;
    }
  });
  if (n) ed.view.dispatch(tr);
  return n;
};

export const FirmaPicker = ({ editorRef }) => {
  const [firme, setFirme] = useState([]);
  const [sel, setSel] = useState("");

  useEffect(() => {
    api.get("/studio/firme-utenti").then(({ data }) => {
      setFirme(data || []);
      if (data?.length) setSel(data[0].id);
    }).catch(() => setFirme([]));
  }, []);

  const cur = firme.find((f) => f.id === sel);
  const onChange = (id) => {
    setSel(id);
    const f = firme.find((x) => x.id === id);
    if (f && replaceFirme(editorRef.current, f)) toast.success(`Firma sostituita con quella di ${f.name}`);
  };
  const insert = () => {
    if (!cur) return;
    editorRef.current?.chain().focus().insertContent(imgHtml(cur)).run();
  };

  if (!firme.length) {
    return <div className="mb-2 text-xs text-slate-500" data-testid="firma-picker-empty">Nessuna firma grafica salvata dagli utenti dello studio.</div>;
  }
  return (
    <div className="mb-2 flex items-center gap-2 flex-wrap" data-testid="firma-picker">
      <span className="text-xs text-slate-400 flex items-center gap-1"><PenLine className="h-3.5 w-3.5" />Firma</span>
      <Select value={sel} onValueChange={onChange}>
        <SelectTrigger className="h-9 w-64 bg-white" data-testid="firma-picker-select">
          <SelectValue placeholder="Seleziona firma" />
        </SelectTrigger>
        <SelectContent>
          {firme.map((f) => (
            <SelectItem key={f.id} value={f.id} data-testid={`firma-picker-option-${f.id}`}>
              <span className="flex items-center gap-2">
                <img src={f.image} alt="" className="h-6 max-w-[90px] object-contain bg-white border rounded" />
                <span>{f.name}{f.role === "titolare" ? " (titolare)" : ""}</span>
              </span>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <button type="button" onClick={insert} data-testid="firma-picker-insert-btn" className="h-9 px-3 text-xs font-semibold rounded-md bg-amber-500 text-slate-900 hover:bg-amber-400 transition-colors">Inserisci firma</button>
    </div>
  );
};
